/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PageLoading from '../common/PageLoading';
import * as discussionActions from '../../actions/discussionActions';
import NotFound from '../common/NotFound';
import Paging from '../common/Paging.js';
import * as qs from 'query-string';
import moment from 'moment';
import ErrorMessage from '../common/ErrorMessage.js';
import * as imageUtils from '../../utils/imageUtils';

class DiscussionPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.loadDiscussions = this.loadDiscussions.bind(this);
        this.getTitle = this.getTitle.bind(this);
        const params = qs.parse(this.props.location.search);
        this.state = {
            loading: false,
            loadingError: false,
            page: params.page || 1,
        };
    }

    componentWillMount() {
        if(!this.props.section || !this.props.discussions) {
            this.loadDiscussions(this.state.page);
        }        
    }

    componentWillUpdate(nextProps, nextState) {
        const params = qs.parse(nextProps.location.search);
        if(params.page && params.page !== this.state.page) {
            this.setState({ page: params.page });
        }
        if(this.state.page !== nextState.page) {
            this.loadDiscussions(nextState.page);
        }
    }

    loadDiscussions(page = 1, forceReload = false) {
        const sectionLink = this.props.match.params.sectionLink;
        this.setState({ loading: true, loadingError: false });
        //we're already checking all this in the action
        //if(forceReload || !this.props.discussions || this.props.discussions.page !== page || new Date(this.props.discussions.lastLoaded) > moment().subtract(1, 'minutes')) {
            this.props.actions.getDiscussions(sectionLink, page)        
            .then(_ => {
                this.setState({
                    loading: false,
                    loadingError: false
                });
            })
            .catch(error => {
                this.setState({ loading: false, loadingError: true });
            });
        //}
    } 
    
    getTitle() {
        if(this.props.discussions.Page === 1) {
            return `${this.props.section.Name} - Discussions - LoudUp`;
        }
        else{
            return `${this.props.section.Name} (Page ${this.props.discussions.Page}) - Discussions - LoudUp`;
        }
    }

    getThumbnail(imageUrl, roleType) {
        const params = '?width=40&aspectw=1&quality=80&mode=crop&format=jpg';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    }

    render() {
        return (
            <div className="main">
                {
                    this.props.discussions ?
                        <React.Fragment>                               
                            <MetaTags>      
                                <title>{this.getTitle()}</title>   
                                <meta id="description" name="description" content={`Discussions - ${this.props.section.Description}`} />   
                            </MetaTags>
                            <div className="container">
                                <div className="block-inner minimal-height">
                                    <h1 className="section-alt">Discussions</h1>
                                    <div className="row">
                                        <div className="col-md-12 minimal-height">
                                            <div>
                                                <div className="discbread">
                                                    <ol className="breadcrumb">
                                                        <li><Link to={'/Discussions'}>Discussions</Link></li>
                                                        <li className="active">{this.props.section.Name}</li>
                                                    </ol>
                                                </div>
                                                <ul className="list-unstyled itemlist discussion">
                                                    <li key="header" className="head">
                                                        <div>
                                                            <div className="disc-icon">
                                                                <svg className="icon icn-discussion">
                                                                    <use xlinkHref="#icn-discussion" />
                                                                </svg>
                                                            </div>
                                                            <h3>{this.props.section.Name}</h3>
                                                            <p className="desc">{this.props.section.Description}</p>
                                                        </div>
                                                        <Link to={`/Discussions/${this.props.section.Link}/NewDiscussion`} className="btn btn-darkrounded btn-newdisc">
                                                            <svg className="icon icn-newdisc">
                                                                <use xlinkHref="#icn-newdisc" />
                                                            </svg>
                                                            NEW DISCUSSION
                                                        </Link>
                                                    </li>
                                                    {
                                                        this.props.discussions.Items.length ?
                                                            this.props.discussions.Items.map(item =>
                                                                <li key={item.ID} className="discpost">
                                                                    <Link to={`/Discussions/${this.props.section.Link}/${item.Link}`} >
                                                                        <div className="userthumb">
                                                                            <img src={this.getThumbnail(item.AuthorImageUrl, item.AuthorRoleType)} alt={item.AuthorDisplayName} />
                                                                        </div>
                                                                        <h3>{item.Title}</h3>
                                                                        <p className="stat" style={{color: '#aaa'}}>{item.PreviewText}</p>
                                                                        <p className="stat">VIEWS: <strong>{item.ViewCount}</strong> · REPLIES: <strong>{item.ReplyCount}</strong></p>
                                                                        <p className="discno">LAST POST: <strong>{item.LastPostDateText}</strong></p>
                                                                    </Link>
                                                                </li>    
                                                            )
                                                        :
                                                            <li>
                                                                <p>Sorry, there are currently no discussions here yet. You can start one though! :)</p>
                                                            </li>
                                                    }                                                    
                                                </ul>
                                                {
                                                    this.props.discussions.TotalPages > 1 ?
                                                        <Paging page={this.props.discussions.Page} totalPages={this.props.discussions.TotalPages} baseUrl={this.props.location.pathname} />
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    :
                        this.state.loading ? 
                            <PageLoading /> 
                            : 
                                this.state.loadingError ?
                                    <div className="container">
                                        <div className="block-inner minimal-height">
                                            <ErrorMessage error="Sorry, something went wrong! Unable to load discussion." />
                                        </div>
                                    </div>
                                    :   
                                    <NotFound />
                }                
            </div>
        );
    }
}

DiscussionPage.propTypes = {
    section: PropTypes.object,
    actions: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    discussions: PropTypes.object,
    match: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {    
    const sectionLink = ownProps.match.params.sectionLink;
    let discussions = null;
    let section = state.discussions.sections ? state.discussions.sections.find(s => s.Link === sectionLink) : null;
    if(section && section.discussions) {
        const dateMinus1Minute = moment().subtract(1, 'minutes');
        if(new Date(section.discussions.lastLoaded) > dateMinus1Minute) {
            discussions = section.discussions;
        }        
    }
    return {
        section,
        discussions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, discussionActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscussionPage);